import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest } from "redux-saga/effects";
import { clearErrors, returnErrors } from "../actions/errorAction";
import { uploadedAuctionListFailure, uploadedAuctionListSuccess } from "../actions/fetchAuctionUploadedListAction";


function* asyncUploadedAuctionRequestSaga(action){

    try{
    yield put(clearErrors());
    let uploadedAuctionResult = yield call(_api.uploadedAuctionRequestApi,{
        accessToken: action.payload.accessToken,
        auction_group:action.payload.auction_group,
    })
     yield put(uploadedAuctionListSuccess({uploadedAuctionResult}));
    }catch(e){
        yield put(uploadedAuctionListFailure({error:e}));
        yield put(returnErrors({msg:e.message, status: true}))
    }
}

export default function* uploadedAuctionRequestSaga(){
    yield takeLatest(types.FETCH_UPLOADED_AUCTION_REQUEST,asyncUploadedAuctionRequestSaga)
}